<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import { fetchDataApps } from '../../api.js';
    import UserStore from '../../stores/user.js';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 


    export let params;

    let isLoading = false; 
    
    let categories = [];
    
    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
        
        isLoading = true;

        let postData = {
            action : 'get_categories',
            token : $UserStore.data
        };
        let data = await fetchDataApps(postData);
        if (data.categories) {
            categories = data.categories;
        }

        isLoading = false;        

 
      
    })    


</script>


<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">
        <TopInfo />
        <div class="dash-list">
            <div class="w-full items-end justify-between mb-[30px]">
                <h1>{$_('merchandiser.categories')}</h1>                
                <div class="flex">
                    

                    <div class="table table-shipments orders">
                        <div class="head">
                            <div>{$_('merchandiser.name')}</div>
                            <div>{$_('merchandiser.views')}</div>
                            <div></div>
                        </div>
                        {#each categories as item,index}
                        <div class="content">                            
                            <div>
                                <div class="mobile">{$_('merchandiser.name')}</div>
                                <div> 
                                    <div>{item.name}</div>                          
                                </div>
                            </div> 
                            <div>
                                <div class="mobile">{$_('merchandiser.views')}</div>
                                <div> 
                                    <div>{item.view_count}</div>                          
                                </div>
                            </div>    
  
                            <div>
                                <div class="small_button" on:click={()=> push('/merchandiser/views/' + item.id)}>
                                    <span>{$_('merchandiser.open')}</span>
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </div>
                                
                            </div>
                        </div>
                        {/each}
                    </div>


                </div>                
            </div>            
        </div>
    </div>
</div>